import React, { useEffect, useMemo, useRef } from 'react'

import { connect } from 'react-redux'

import {
    getQuickTasks,
} from 'state/actions'

import {
    getCurrentAccount,
} from 'state/selectors'

import { 
	getApplicableUsers
} from 'utils'
import TabContent from 'components/tab-content/tab-content'

import QuickTasksTab from './quick-tasks-tab'

const QuickTasks = ({
    currentAccount,
    getQuickTasks,
    allTasks,
    allTeams,
    allProjects,
    allUsers
}) => {
    const allColumnsRef = useRef([])
    const allColumns = allColumnsRef.current

    useEffect(() => {
        getQuickTasks(currentAccount.id, columns => {
            allColumnsRef.current = columns
        })
    }, [])

    const tabs = [
        {
            id: 0,
            name: `Unassigned`,
            props: {
                emptyCopy: `Assign resourcing tasks from within a project.`
            },
            Component: QuickTasksTab
        },{
            id: 1,
            name: `Assigned`,
            props: {
                emptyCopy: `Tasks with a user assigned, but no status, with appear here.`
            },
            Component: QuickTasksTab
        },{
            id: 2,
            name: `Active`,
            props: {
                emptyCopy: `Tasks with both a user and a status will appear here.`
            },
            Component: QuickTasksTab
        }
    ]

    const tasksByTabName = useMemo(() => {
        if (!currentAccount || !currentAccount.quickTasks) {
            return []
        }

        const response = {}

        tabs.forEach(tab => {
            response[tab.name] = []
        })

        currentAccount.quickTasks.forEach(taskId => {
            const task = allTasks[taskId]

            if (!task || !task.is_quick_task) {
                return null
            }

            const parentProject = allProjects[task.project_id]

            if(!parentProject){
                return null
            }

            // Little mutations, just because we HAVE to.
            task.parentColumns = parentProject.columns

            const primaryStatusColumn = task.parentColumns.find(column => (column.type === 'STATUS' && column.is_primary))
            const primaryPeopleColumn = task.parentColumns.find(column => (column.type === 'PEOPLE' && column.is_primary))

            const statusId = (task.column_data && primaryStatusColumn && task.column_data[primaryStatusColumn.id]) ? task.column_data[primaryStatusColumn.id] : null
            const peopleIds = (task.column_data && primaryPeopleColumn && task.column_data[primaryPeopleColumn.id]) ? task.column_data[primaryPeopleColumn.id] : []

            if(statusId === 3){
                return null
            }

            if(parentProject){
                const applicableUsers = getApplicableUsers(currentAccount, allUsers, parentProject, allTeams)
                task.applicableUserIds = applicableUsers.map(_user => (_user ? _user.id : null))
            }

            let tabName = 'Unassigned'

            if(statusId && peopleIds.length){
                tabName = 'Active'
            }else if(peopleIds.length){
                tabName = 'Assigned'
            }

            response[tabName].push(task)
        })

        Object.keys(response).forEach(tabName => {
            response[tabName].sort((a,b) => {
                const getStartDate = task => {
                    const column = task.parentColumns.find(column => (column.type === 'DATE' && column.is_primary))

                    if(!column){
                        return '9999'
                    }

                    const columnData = (task.column_data && task.column_data[column.id]) ? task.column_data[column.id] : { start: null, end: null}
    
                    return columnData.start || '9999'
                }
    
                const aStartDate = getStartDate(a)
                const bStartDate = getStartDate(b)
    
                return (aStartDate < bStartDate ? -1 : (aStartDate > bStartDate ? 1 : 0))
            })
        })

        return response
    }, [allTasks, allColumns])

    tabs.forEach(tab => {
        tab.props.tasks = tasksByTabName[tab.name]
    })

    return (
        <div>
            <TabContent 
                tabs={tabs}
                showCount
            />
        </div>
    )
}

const mapStateToProps = state => {
    return {
        currentAccount: getCurrentAccount(state),
        allTasks: state.account.entities.tasks,
        allUsers: state.account.entities.users,
        allTeams: state.account.entities.teams,
        allProjects: state.account.entities.projects
    }
}

export default connect(mapStateToProps, {
    getQuickTasks,
})(QuickTasks)